import PositioningDeviceFittingsDetailModal from './positioning-device-fittings-detail-modal.vue'
export default PositioningDeviceFittingsDetailModal
